import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
import BcDialog, { CBcDialog, CBcDialogForm } from '@/components/Dialog.vue';
import BcCreateRecord, { BcNRDialog } from '@/components/CreateRecord.vue';
import { CBcHospitalHisInfo, CBcHospitalHisConfigDatabase, CBcHospitalHisConfigWebService, CBcHospitalHandlerInfo } from '@/classes/BcClasses';
import BcHisInfo from '@/components/HisInfo.vue';
class CHisForm extends CBcDialogForm {
    constructor(type, op) {
        super();
        const that = this;
        that.type = type;
        if (op && /object/i.test(typeof op)) {
            Object.keys(op).forEach((k) => {
                if (k !== 'info')
                    that[k] = op[k];
            });
        }
        that.info = /web/i.test(that.type) ? new CBcHospitalHisConfigWebService(op && op.info) : new CBcHospitalHisConfigDatabase(op && op.info);
    }
}
class CHandlerForm extends CBcDialogForm {
    constructor(type, op) {
        super();
        const that = this;
        if (op && /object/i.test(typeof op)) {
            Object.keys(op).forEach((k) => {
                that[k] = op[k];
            });
        }
    }
}
let HospInfo = class HospInfo extends Vue {
    constructor() {
        super();
        this.snackbar = new CBcSnackbar();
        this.menus = {
            deviceMore: []
        };
        this.list = [];
        this.menuDate = {
            visible: false,
            picker: new Date().toISOString().substr(0, 10)
        };
        this.dialog = {
            editor: -1,
            title: '',
            text: '',
            visible: false,
            loading: false,
            isEditDevice: false,
        };
        this.dlgNewRecord = new BcNRDialog();
        this.region = {
            menu: {
                visible: false
            },
            isEditing: false,
            active: [],
            province: {
                list: [],
                value: undefined,
                loading: false,
            },
            city: {
                list: [],
                value: undefined,
                loading: false,
            },
            area: {
                list: [],
                value: undefined,
                loading: false,
            },
        };
        this.queryRegion = {
            menu: {
                visible: false
            },
            isEditing: false,
            active: [],
            province: {
                list: [],
                value: undefined,
                loading: false,
            },
            city: {
                list: [],
                value: undefined,
                loading: false,
            },
            area: {
                list: [],
                value: undefined,
                loading: false,
            },
        };
        this.winItem = {
            value: 0,
            selectHospital: null
        };
        this.device = {
            noCorrelations: [],
            filter: {
                dept: 0
            }
        };
        this.searchOptions = {
            text: '',
            deviceBindingType: 0 // 默认选中"所有"
        };
        this.hisInfo = new CBcHospitalHisInfo();
        this.handlerInfo = new CBcHospitalHandlerInfo();
        this.panelsModel = [];
        this.hisPasswordVisible = false;
        this.dialogHis = new CBcDialog(new CHisForm());
        this.regionCatalogLoading = false;
        this.hisFormDatabaseFields = [
            { name: '数据库类型', key: 'type' },
            { name: '数据库版本', key: 'version' },
            { name: '数据库字符', key: 'characterSet' },
            { name: '数据库地址', key: 'address' },
            { name: '数据库端口', key: 'port' },
            { name: '数据库名称', key: 'database' },
            { name: '数据库模式', key: 'schema' },
            { name: '服务名称', key: 'serverName' },
            { name: '连接用户', key: 'username' },
            { name: '连接密码', key: 'password' },
        ];
        this.regionCatalogList = [];
        this.pageLoading = false;
        this.isSummaryDetail = false; // 是否开启明细统计
        this.selectHospitalInfo = {
            loading: false,
            hospInfo: {},
            localHospInfo: [] // 本地缓存的医院
        };
        this.onStateOption = [{
                prop: '正常使用',
                class: 'on-state-info-primary'
            }, {
                prop: '未装机',
                class: 'on-state-info-orange'
            }, {
                prop: '停用',
                class: 'on-state-info-red'
            }, {
                prop: '入场',
                class: ''
            }, {
                prop: '入仓',
                class: ''
            }, {
                prop: '测试',
                class: ''
            }, {
                prop: '临床',
                class: 'on-state-info-primary'
            }];
        // 医院人员信息
        this.dialogHandlers = new CBcDialog(new CHandlerForm());
        this.userInfoDic = {
            list: [],
            value: undefined,
            loading: true
        };
        this.converArray = ['transfer', 'technicist', 'salesman', 'manager', 'secondManager'];
        const that = this;
        this.formData = {
            area: '',
            name: '',
            dept: '',
            date: '',
            address: '',
            creator: '',
            remark: '',
            managerArray: '',
            secondManagerArray: '',
            transferArray: [],
            technicistArray: [],
            salesmanArray: [],
            handlerRemark: '',
            handlerId: null,
        };
        this.currentItem = {
            area: '',
            name: '',
            dept: '',
            address: '',
            date: '',
            creator: '',
            remark: '',
        };
        this.formDeviceData = {
            id: null,
            deviceId: null,
            hospitalId: null,
            deviceNo: '',
            devices: [],
        };
    }
    async mounted() {
        const that = this;
        await that.getList();
        await that.initRegionData();
        await that.initUserList();
        that.getRegionCatalogList();
        const selectRouteId = that.$route.params.id;
        if (selectRouteId) {
            const item = that.list.find((v) => v.id === Number(selectRouteId));
            if (item) {
                that.hospitalSelected(item);
                that.winItem.value = 1;
            }
            const { isOpenPersonnelPanels } = that.$route.params;
            if (isOpenPersonnelPanels)
                that.panelsModel.push(1);
            // that.$router.replace({ name: 'HospitalInfo', params: {} })
        }
        // 异步加载配药记录统计等
        that.setHospCountInfo();
    }
    onRegionProvinceValueChange(newVal) {
        const that = this;
        if (!newVal) {
            that.region.city.value = undefined;
            that.region.area.value = undefined;
            that.region.province.loading = true;
            that.initRegionData();
            return;
        }
        // const pIt = that.region.province.list.find(v => v.code === newVal)
        that.region.city.loading = true;
        that.getRegionList(newVal).then((res) => {
            that.region.city.list = res;
            that.region.city.loading = false;
        }).catch((e) => {
            console.log('error of get region with city:', e);
            that.region.city.loading = false;
        });
    }
    onRegionCityValueChange(newVal) {
        const that = this;
        if (!newVal) {
            that.region.area.value = undefined;
            return;
        }
        // const cIt = that.region.city.list.find((v:any) => v.code === newVal)
        that.region.area.loading = true;
        that.getRegionList(that.region.province.value, newVal).then((res) => {
            that.region.area.loading = false;
            that.region.area.list = res;
        }).catch((e) => {
            console.log('error of get region with area:', e);
            that.region.area.loading = false;
        });
    }
    async onWinItemValueChange(newVal) {
        const that = this;
        if (newVal === 1) {
            await that.getAvailableDevices();
        }
    }
    async onDeviceFilterDeptChange(newVal) {
        const that = this;
        if (that.winItem.value === 1) {
            if (that.winItem.selectHospital) {
                const depts = that.currentHospDeviceDepts;
                const current = depts && depts[newVal];
                that.winItem.selectHospital.devices.map((v) => {
                    v['display'] = current === '所有' ? true : (v.dept === current);
                    return v;
                });
            }
        }
    }
    onDialogHisFormTypeChanged(newVal) {
        const that = this;
        if (that.dialogHis.isCreateType) {
            that.dialogHis.form.info = /web/i.test(that.dialogHis.form.info.type) ? new CBcHospitalHisConfigWebService() : new CBcHospitalHisConfigDatabase();
        }
    }
    /**
     * 将数组对象转换成字符数组
     * @param array
     * @param key 默认为name
     */
    arrayToStringByKey(array, key = 'name') {
        return (array || []).map((v) => v[key]) || [];
    }
    async refreshList() {
        const that = this;
        await that.getList();
        that.getRegionCatalogList();
        that.setHospCountInfo();
    }
    get currentHospDeviceDepts() {
        const that = this;
        return ['所有'].concat(that.winItem.selectHospital && that.winItem.selectHospital.devices.map((v) => v.dept)
            .filter((item, index, self) => item && self.indexOf(item) === index));
    }
    get allowDialogPositive() {
        const that = this;
        if (that.winItem.value === 1) {
            switch (that.dialog.editor) {
                case 1:
                    return that.formDeviceData && that.formDeviceData.devices && that.formDeviceData.devices.length > 0;
                default:
                    return true;
            }
        }
        else {
            switch (that.dialog.editor) {
                case 3:
                    return that.currentItem && that.currentItem.devices && that.currentItem.devices.length <= 0;
                default:
                    return true;
            }
        }
    }
    get currentHospitalDevices() {
        const that = this;
        return that.winItem.value === 1 ? (that.winItem.selectHospital && that.winItem.selectHospital.devices && that.winItem.selectHospital.devices.length || 0) : 0;
    }
    getAvailableDevices() {
        const that = this;
        return that.axios.get('/api/device', { params: { noCorrelation: true } }).then((res) => {
            that.device.noCorrelations = res && res.data && res.data.result || [];
            return res;
        });
    }
    jumpToMalfunctionPage(item) {
        const that = this;
        that.$router.push({ name: 'Malfunction', query: { device: item } });
    }
    removeSelectedDevice(item) {
        const that = this;
        const index = that.formDeviceData.devices.map((v) => v.id).indexOf(item.id);
        if (index >= 0 && (that.dialog.editor === 1))
            that.formDeviceData.devices.splice(index, 1);
    }
    initRegionData() {
        const that = this;
        that.getRegionList('').then((res) => {
            that.region.province.loading = false;
            that.region.province.list = res;
            // that.initQueryRegionData(that.list);
        }).catch((e) => {
            console.log('error of get region with area:', e);
            that.region.province.loading = false;
            that.queryRegion.province.loading = false;
        });
    }
    // 初始化查询的区域
    initQueryRegionData(list) {
        const that = this;
        const res = that.region.province.list;
        if (res) {
            res.filter((o) => o['count'] = 0);
        }
        // 处理各省份医院数
        if (list) {
            list.forEach((o) => {
                if (o.area) {
                    // 截取省份
                    const province = o.area.split('-')[0];
                    const findModel = res.find((e) => e.name == province);
                    if (findModel) {
                        findModel.count += 1;
                    }
                }
            });
            // 处理城区
            // 城市个数统计
            if (that.queryRegion.city.list) {
                that.queryRegion.city.list.forEach((o) => {
                    // 截取省份-城市
                    const str = `${that.queryRegion.province.value}-${o.name}`;
                    const queryList = list.filter((e) => e.area && e.area.indexOf(str) > -1);
                    o['count'] = queryList ? queryList.length : 0;
                });
            }
        }
        that.queryRegion.province.loading = false;
        that.queryRegion.province.list = res;
    }
    onQueryRegionProvinceValueChange(newVal) {
        const that = this;
        if (!newVal) {
            that.queryRegion.city.value = undefined;
            that.queryRegion.area.value = undefined;
            that.queryRegion.province.loading = true;
            that.initRegionData();
            return;
        }
        // 清理城区值
        that.queryRegion.area.list = undefined;
        that.queryRegion.area.value = undefined;
        that.queryRegion.city.value = undefined;
        that.queryRegion.city.loading = true;
        that.getRegionList(newVal).then((res) => {
            that.queryRegion.city.list = res || [];
            that.queryRegion.city.loading = false;
        }).catch((e) => {
            console.log('error of get queryRegion with city:', e);
            that.queryRegion.city.loading = false;
        });
    }
    onQueryRegionCityValueChange(newVal) {
        const that = this;
        if (!newVal) {
            that.queryRegion.area.value = undefined;
        }
        // const cIt = that.region.city.list.find((v:any) => v.code === newVal)
        // that.queryRegion.area.loading = true
        // that.getRegionList(that.queryRegion.province.value, newVal).then((res: any) => {
        //   that.queryRegion.area.loading = false
        //   that.queryRegion.area.list = res
        // }).catch((e: any) => {
        //   console.log('error of get region with area:', e)
        //   that.queryRegion.area.loading = false
        // })
    }
    regionComfirm() {
        const that = this;
        that.formData.area = [that.region.province.value, that.region.city.value, that.region.area.value].filter(v => Boolean(v)).join('-');
        that.region.menu.visible = false;
    }
    getRegionList(province, city, area) {
        const that = this;
        try {
            let url = '/api/region';
            if (province !== undefined && city !== undefined && area !== undefined)
                url = `/api/region/provinces/${province}/cities/${city}/areas/${area}`;
            else if (province !== undefined && city !== undefined)
                url = `/api/region/provinces/${province}/cities/${city}`;
            else if (province !== undefined)
                url = `/api/region/provinces/${province}`;
            return that.axios.get(url).then((res) => res.data);
        }
        catch (e) {
            console.log('get region error:', e);
        }
    }
    regionFilter(item, queryText, itemText) {
        return new RegExp(queryText.toUpperCase(), 'i').test(item['pinYin'].toUpperCase())
            || new RegExp(queryText.toUpperCase(), 'i').test(item['name'].toUpperCase())
            || new RegExp(queryText.toUpperCase(), 'i').test(item['code'].toUpperCase());
    }
    async getList() {
        const that = this;
        that.pageLoading = true;
        try {
            const res = (await that.axios.get('/api/hospital?isSummaryDetail=' + that.isSummaryDetail));
            that.pageLoading = false;
            that.list = res && res.data && res.data.result || [];
        }
        catch (e) {
            that.pageLoading = false;
            console.log('error of get list:', e);
            that.snackbar.error(e.errorInfo || e.result || e.toString() || '医院信息获取失败.');
        }
    }
    // 处理医院配药情况汇总 入参选中的医院实体
    async initHospitalCount(item) {
        const that = this;
        that.selectHospitalInfo.loading = true;
        // 本地缓存中读取
        const model = that.selectHospitalInfo.localHospInfo.find((o) => o.id == item.id);
        if (model) {
            // 本地存在 直接读取 不访问接口
            that.selectHospitalInfo.hospInfo = model;
        }
        else {
            // 访问接口获取数据
            const list = await that.getListById(item.id);
            if (list && list.length > 0) {
                that.selectHospitalInfo.localHospInfo.push(list[0]);
                that.selectHospitalInfo.hospInfo = list[0];
            }
        }
        that.selectHospitalInfo.loading = false;
    }
    // 获取医院的统计信息
    async getListById(id) {
        const that = this;
        const res = (await that.axios.get('/api/hospital?id=' + id));
        return res && res.data && res.data.result || [];
    }
    // 写入医院统计信息
    async setHospCountInfo() {
        const that = this;
        const data = await that.getHospCountInfo();
        if (!data || data.length == 0) {
            return;
        }
        data.forEach((item) => {
            // 在本地的list中修改数据
            const model = that.list.find((o) => o.id == item.id);
            if (model) {
                model.devices = item.devices;
                model.isShowConut = true; // 显示统计
            }
            const localModel = that.selectHospitalInfo.localHospInfo.find((o) => o.id == item.id);
            // 不存在就添加 点详情时没加载完就单个获取加载
            if (!localModel) {
                that.selectHospitalInfo.localHospInfo.push(model);
            }
        });
    }
    // 获取医院统计信息 执行顺序需要在执行完获取整个列表之后
    async getHospCountInfo() {
        const that = this;
        const res = (await that.axios.get('/api/hospital'));
        return res && res.data && res.data.result || [];
    }
    async getRegionCatalogList() {
        const that = this;
        that.regionCatalogLoading = true;
        try {
            const res = (await that.axios.get('/api/hospital/region/catalog'));
            that.regionCatalogLoading = false;
            that.regionCatalogList = ((res && res.data && res.data.result || []).province || []).map((v) => {
                if (!v.province)
                    v.province = '未知';
                return v;
            });
        }
        catch (e) {
            that.regionCatalogLoading = false;
            console.log('error of get region list:', e);
            that.snackbar.error(e.errorInfo || e.result || e.toString() || '医院region信息获取失败.');
        }
    }
    updateHospital(hospid) {
        const that = this;
        return that.axios.get('/api/hospital/' + hospid + '/device').then((res) => {
            if (that.winItem.selectHospital.id === hospid)
                that.winItem.selectHospital = res.data && res.data.result;
            that.list = that.list.map((v) => {
                if (v.id === hospid) {
                    v = res.data && res.data.result;
                }
                return v;
            });
            return res;
        });
    }
    backTo() {
        const that = this;
        that.winItem.value = 0;
        that.panelsModel = [];
        that.hisPasswordVisible = false;
        // that.getList()
    }
    deleteItem(item, device) {
        const that = this;
        that.dialog.editor = 3;
        if (that.winItem.value === 1) {
            // @ts-ignore
            that.formDeviceData = { devices: [], id: device.id }; // 关系表ID
            that.dialog.title = '从当前医院移除设备';
            that.dialog.text = `请确认是否解除设备${device && device['name'] || ''}与该医院的关联，同时删除设备维护计划，操作不可恢复，请谨慎操作.`;
        }
        else {
            that.currentItem = JSON.parse(JSON.stringify(item));
            that.dialog.title = '删除医院' + (that.allowDialogPositive ? '' : '无效');
            that.dialog.text = that.allowDialogPositive ? `请确认是否删除${item && item['name'] || ''}该医院，操作不可恢复.` : '当前医院下有关联的设备，无法删除，请先移除所有关联设备后重试.';
        }
        that.dialog.visible = true;
    }
    editItem(item, device) {
        const that = this;
        that.dialog.editor = 2;
        that.dialog.title = that.winItem.selectHospital ? '编辑设备' : '编辑医院';
        that.dialog.text = '';
        // @ts-ignore
        that.dialog.isEditDevice = Boolean(that.winItem.selectHospital);
        if (that.winItem.value === 1) {
            const deviceItem = JSON.parse(JSON.stringify(device));
            if (/string/i.test(typeof deviceItem.onState))
                deviceItem.onState = deviceItem.onState.split(',');
            that.formDeviceData = deviceItem;
            // @ts-ignore
            that.formDeviceData.devices = [{
                    id: deviceItem.id,
                    deviceId: device.deviceId,
                    deviceNo: deviceItem.deviceNo,
                    name: deviceItem.name
                }];
        }
        else {
            that.currentItem = item;
            that.formData = JSON.parse(JSON.stringify(item));
            const regionText = String(that.formData.area).split('-');
            that.region.province.value = regionText && regionText[0] || '';
            that.region.city.value = regionText && regionText[1] || '';
            that.region.area.value = regionText && regionText[2] || '';
            that.loadHospitalHandlerInfo(item.id);
        }
        that.dialog.visible = true;
    }
    createNew() {
        const that = this;
        that.currentItem = undefined;
        that.dialog.editor = 1;
        that.dialog.title = that.winItem.value === 1 ? '添加设备' : '新增医院';
        that.dialog.text = '';
        if (that.winItem.value === 1) {
            that.dialog.loading = true;
            that.formDeviceData.devices = [];
            that.updateHospital(that.winItem.selectHospital.id).then((res) => {
                that.dialog.loading = false;
            }).catch((e) => {
                that.dialog.loading = false;
                console.log('获取设备列表出错:', e);
            });
        }
        else {
            that.formData = {
                creator: that.userInfo.name,
                managerArray: '',
                secondManagerArray: '',
                transferArray: [],
                technicistArray: [],
                salesmanArray: [],
                handlerRemark: '',
                handlerId: null,
            };
        }
        that.dialog.visible = true;
    }
    async createNewHandle() {
        const that = this;
        if (that.winItem.value === 1) {
            const body = {
                devices: that.formDeviceData.devices,
                dept: that.formDeviceData.dept,
                settlement: that.formDeviceData.settlement,
                deliveryState: that.formDeviceData.deliveryState,
                onState: that.formDeviceData.onState && (that.formDeviceData.onState instanceof Array ? that.formDeviceData.onState.join(',') : that.formDeviceData.onState)
            };
            await that.axios.post(`/api/hospital/${that.winItem.selectHospital.id}/device`, body);
            await that.getAvailableDevices();
            return that.updateHospital(that.winItem.selectHospital.id);
        }
        else {
            const body = JSON.parse(JSON.stringify(that.formData));
            body['area'] = body && body.area && body.area.text || body.area;
            return that.axios.post('/api/hospital', body);
        }
    }
    async editItemHandle() {
        const that = this;
        const body = that.winItem.value === 1 ? that.formDeviceData : that.formData;
        if (that.winItem.value === 1) {
            const dUrl = '/api/hospital/' + that.winItem.selectHospital.id + '/device';
            const iBody = {
                id: body.id,
                dept: that.formDeviceData.dept,
                settlement: body.settlement,
                deliveryState: body.deliveryState,
                onState: body.onState && (body.onState instanceof Array ? body.onState.join(',') : body.onState)
            };
            return that.axios.put(dUrl, iBody);
        }
        else {
            body['area'] = body && body.area.text || body.area;
            return that.axios.put('/api/hospital/' + that.currentItem.id, body);
        }
    }
    async deleteItemHandle() {
        const that = this;
        if (that.winItem.value === 1)
            return that.axios.delete('/api/hospital/' + that.winItem.selectHospital.id + '/device/' + that.formDeviceData.id);
        else
            return that.axios.delete('/api/hospital/' + that.currentItem.id);
    }
    close() {
        const that = this;
        that.dialog.visible = false;
    }
    async save() {
        const that = this;
        const typeName = (that.dialog.editor === 1 ? '新增' : that.dialog.editor === 2 ? '修改' : '删除')
            + (that.winItem.value === 1 ? '医院设备' : '医院信息');
        try {
            let hospitalId = 0;
            switch (that.dialog.editor) {
                case 1:
                    const createResult = await that.createNewHandle();
                    if (that.winItem.value !== 1) {
                        hospitalId = createResult && createResult.data && createResult.data.result && createResult.data.result.id;
                        await that.saveHospitalHandler(hospitalId, false);
                    }
                    break;
                case 2:
                    await that.editItemHandle();
                    if (that.winItem.value !== 1) {
                        hospitalId = that.currentItem && that.currentItem.id;
                        await that.saveHospitalHandler(hospitalId, true);
                    }
                    break;
                case 3:
                    await that.deleteItemHandle();
                    break;
                default:
                    break;
            }
            that.dialog.visible = false;
            if (that.winItem.value === 1) {
                that.formDeviceData = { devices: [] };
                await that.getAvailableDevices();
                await that.updateHospital(that.winItem.selectHospital.id);
            }
            else {
                that.region.province.list = [];
                that.region.province.value = undefined;
                that.region.city.list = [];
                that.region.city.value = undefined;
                that.region.area.list = [];
                that.region.area.value = undefined;
                that.getList();
            }
            that.snackbar.success(`${typeName}成功`);
        }
        catch (e) {
            console.log('save handle error:', e);
            if (that.dialog.editor === 3)
                that.dialog.visible = false;
            that.snackbar.error(e.error || e.info || e.errorInfo || e.result || e.toString() || `${typeName}失败`);
        }
    }
    get listFilter() {
        const that = this;
        const itext = that.searchOptions.text;
        let l = [];
        l = that.list.filter((v) => {
            const reg = new RegExp(itext, 'i');
            return (itext === null || itext === undefined || !itext.length) ? v : (reg.test(String(v.spell)) || reg.test(v.name));
        }); // 根据快捷查询过滤
        that.initQueryRegionData(l);
        if (l && l.length > 0) {
            // 根据区域地址过滤
            const areaArray = [];
            if (that.queryRegion.province && that.queryRegion.province.value) {
                areaArray.push(that.queryRegion.province.value);
            }
            if (that.queryRegion.city && that.queryRegion.city.value) {
                areaArray.push(that.queryRegion.city.value);
            }
            if (that.queryRegion.area && that.queryRegion.area.value) {
                areaArray.push(that.queryRegion.area.value);
            }
            if (areaArray.length > 0) {
                const areaStr = areaArray.join('-');
                l = l.filter((v) => {
                    const reg = new RegExp(areaStr, 'i');
                    return reg.test(v.area);
                }); // 根据快捷查询过滤
            }
        }
        // 根据售后负责人过滤（模糊匹配）
        if (that.searchOptions.afterSalesManager) {
            if (that.searchOptions.afterSalesManager === '无') {
                l = l.filter((v) => {
                    return !v.handlerManager;
                });
                return l;
            }
            else {
                const managerReg = new RegExp(that.searchOptions.afterSalesManager, 'i');
                l = l.filter((v) => {
                    return v.handlerManager && managerReg.test(v.handlerManager);
                });
            }
        }
        // 根据销售过滤（模糊匹配）
        if (that.searchOptions.salesManager) {
            const salesReg = new RegExp(that.searchOptions.salesManager, 'i');
            l = l.filter((v) => {
                return v.handlerSalesman && salesReg.test(v.handlerSalesman);
            });
        }
        // 根据设备绑定状态过滤
        if (that.searchOptions.deviceBindingType) {
            if (that.searchOptions.deviceBindingType === 1) {
                // 已绑定：有设备的医院
                l = l.filter((v) => {
                    return v.devices && v.devices.length > 0;
                });
            }
            else if (that.searchOptions.deviceBindingType === 2) {
                // 无设备：没有设备的医院
                l = l.filter((v) => {
                    return !v.devices || v.devices.length === 0;
                });
            }
            // 0: 所有，不过滤
        }
        return l;
    }
    formatDate(iDate) {
        const date = new Date(iDate).toISOString().substr(0, 10);
        if (!date)
            return null;
        const [year, month, day] = date.split('-');
        return `${year}-${month}-${day}`;
    }
    async hospitalSelected(item) {
        const that = this;
        that.winItem.selectHospital = item;
        that.winItem.value = 1;
        that.getHisInfo(that.winItem.selectHospital && that.winItem.selectHospital.id || 0);
        // 获取医院统计信息
        that.initHospitalCount(item);
        // 获取医院人员信息
        that.getHospitalHandlers();
    }
    async getHisInfo(hid) {
        const that = this;
        try {
            if (!hid)
                hid = that.winItem.selectHospital && that.winItem.selectHospital.id || 0;
            const res = await that.axios.get('/api/hospital/his', { params: { hospitalId: hid } });
            that.hisInfo = new CBcHospitalHisInfo(res.data && res.data.result && res.data.result[0]);
        }
        catch (e) {
            console.log('get hospital his info error:', e);
            that.snackbar.error('获取医院信息系统对接信息过得出错.' + (e && (e.info || e.result || e.error)));
        }
    }
    parseToPasswordText(val) {
        const that = this;
        return that.hisPasswordVisible ? val : '******';
    }
    toggleShowPasswords() {
        const that = this;
        that.hisPasswordVisible = !that.hisPasswordVisible;
    }
    // 获取设备状态class
    getDeviceStatusClass(dit) {
        let classStr = '';
        const that = this;
        that.onStateOption.forEach((element) => {
            if (dit.onState && dit.onState.indexOf(element.prop) > -1 && element.class) {
                classStr += element.class;
            }
        });
        return classStr;
    }
    async hisFormSave(error, msg) {
        const that = this;
        if (!error) {
            await that.getHisInfo(that.winItem.selectHospital && that.winItem.selectHospital.id || 0);
            // 更新医院列表的值
            if (that.hisInfo) {
                that.list.find((o) => o.id == that.hisInfo.hospitalId).hisInfoState = that.hisInfo.state;
            }
        }
    }
    // 获取医院人员信息
    async getHospitalHandlers() {
        const that = this;
        const hid = that.winItem.selectHospital && that.winItem.selectHospital.id || 0;
        const res = await that.axios.get('/api/hospital/handlers/' + hid);
        if (res.data && res.data.result && res.data.result[0]) {
            that.handlerInfo = res.data.result[0];
            that.converArray.forEach((o) => {
                that.handlerInfo[`${o}Array`] = that.handlerInfo[o] ? that.handlerInfo[o].split(',') : [];
            });
        }
        else {
            that.handlerInfo = {};
        }
    }
    // 加载医院人员信息到编辑表单
    async loadHospitalHandlerInfo(hospitalId) {
        const that = this;
        try {
            const res = await that.axios.get('/api/hospital/handlers/' + hospitalId);
            if (res.data && res.data.result && res.data.result[0]) {
                const handlerInfo = res.data.result[0];
                that.$set(that.formData, 'handlerId', handlerInfo.id);
                that.$set(that.formData, 'handlerRemark', handlerInfo.remark || '');
                const singleFields = ['manager', 'secondManager'];
                const multiFields = ['transfer', 'technicist', 'salesman'];
                singleFields.forEach((o) => {
                    that.$set(that.formData, `${o}Array`, handlerInfo[o] || '');
                });
                multiFields.forEach((o) => {
                    that.$set(that.formData, `${o}Array`, handlerInfo[o] ? handlerInfo[o].split(',') : []);
                });
            }
            else {
                that.$set(that.formData, 'handlerId', null);
                that.$set(that.formData, 'handlerRemark', '');
                const singleFields = ['manager', 'secondManager'];
                const multiFields = ['transfer', 'technicist', 'salesman'];
                singleFields.forEach((o) => {
                    that.$set(that.formData, `${o}Array`, '');
                });
                multiFields.forEach((o) => {
                    that.$set(that.formData, `${o}Array`, []);
                });
            }
        }
        catch (e) {
            console.log('加载医院人员信息出错:', e);
        }
    }
    // 保存医院人员信息
    async saveHospitalHandler(hospitalId, isEdit) {
        const that = this;
        try {
            const handlerData = {
                hospitalId: hospitalId,
                remark: that.formData.handlerRemark || ''
            };
            that.converArray.forEach((o) => {
                handlerData[o] = that.formData[`${o}Array`] ? that.formData[`${o}Array`].toString() : '';
            });
            if (isEdit && that.formData.handlerId) {
                await that.axios.put('/api/hospital/handlers/' + that.formData.handlerId, handlerData);
            }
            else {
                await that.axios.post('/api/hospital/handlers', handlerData);
            }
        }
        catch (e) {
            console.log('保存医院人员信息出错:', e);
        }
    }
    handlerDialog(type) {
        const that = this;
        that.dialogHandlers.width = /^xs$/i.test(that.$vuetify.breakpoint.name) ? '95%' : '60%';
        that.dialogHandlers.title = (type == 'add' ? '新增' : type == 'edit' ? '编辑' : '删除') + '医院人员信息';
        that.dialogHandlers.visible = true;
        that.dialogHandlers.displayText = false;
        that.dialogHandlers.autoClose = false;
        that.dialogHandlers.form = new CHandlerForm(type, that.handlerInfo);
    }
    // 保存医院对接人信息
    async dialogHandlerSave() {
        const that = this;
        that.dialogHandlers.loading = true;
        that.dialogHandlers.positive.loading = true;
        try {
            that.converArray.forEach((o) => {
                that.dialogHandlers.form[o] = that.dialogHandlers.form[`${o}Array`] ? that.dialogHandlers.form[`${o}Array`].toString() : '';
            });
            if (that.dialogHandlers.form.id) {
                // 修改
                await that.axios.put('/api/hospital/handlers/' + that.dialogHandlers.form.id, that.dialogHandlers.form);
            }
            else {
                // 新增
                that.dialogHandlers.form.hospitalId = that.winItem.selectHospital && that.winItem.selectHospital.id || 0;
                await that.axios.post('/api/hospital/handlers', that.dialogHandlers.form);
            }
            that.dialogHandlers.loading = false;
            that.dialogHandlers.positive.loading = false;
            that.dialogHandlers.visible = false;
            that.snackbar.success(`${that.dialogHandlers.title}成功！`);
            that.getHospitalHandlers();
        }
        catch (e) {
            that.dialogHandlers.loading = false;
            that.dialogHandlers.positive.loading = false;
            console.log(e);
            that.snackbar.error(`${that.dialogHandlers.title}过程出错:` + (e && (e.info || e.result || e.error)));
        }
    }
    async initUserList() {
        const that = this;
        that.userInfoDic.loading = true;
        try {
            const res = await that.axios.get('/api/users/');
            that.userInfoDic.list = [];
            if (res.data && res.data.result) {
                res.data.result.filter((o) => {
                    if (o.usersInfo)
                        that.userInfoDic.list.push(o.usersInfo);
                });
            }
        }
        catch (e) {
            console.log('error of get user list:', e);
            that.snackbar.error(e.errorInfo || e.result || e.toString() || '用户列表获取失败.');
        }
        finally {
            that.userInfoDic.loading = false;
        }
    }
    deviceFilter(item, queryText) {
        return (new RegExp(queryText.toUpperCase(), 'i').test(item['deviceNo'].toUpperCase())
            || new RegExp(queryText.toUpperCase(), 'i').test(item['name'].toUpperCase()));
    }
};
__decorate([
    Getter
], HospInfo.prototype, "userInfo", void 0);
__decorate([
    Getter
], HospInfo.prototype, "isThirdApp", void 0);
__decorate([
    Watch('region.province.value')
], HospInfo.prototype, "onRegionProvinceValueChange", null);
__decorate([
    Watch('region.city.value')
], HospInfo.prototype, "onRegionCityValueChange", null);
__decorate([
    Watch('winItem.value')
], HospInfo.prototype, "onWinItemValueChange", null);
__decorate([
    Watch('device.filter.dept')
], HospInfo.prototype, "onDeviceFilterDeptChange", null);
__decorate([
    Watch('dialogHis.form.type')
], HospInfo.prototype, "onDialogHisFormTypeChanged", null);
__decorate([
    Watch('queryRegion.province.value')
], HospInfo.prototype, "onQueryRegionProvinceValueChange", null);
__decorate([
    Watch('queryRegion.city.value')
], HospInfo.prototype, "onQueryRegionCityValueChange", null);
HospInfo = __decorate([
    Component({
        name: 'HospitalInfo',
        components: {
            BcSnackbar,
            BcDialog,
            BcCreateRecord,
            BcHisInfo
        },
    })
], HospInfo);
export default HospInfo;
;
